import { useEffect, useState } from 'react';
import './App.css';

function App() {
  const [gameStart, setGameStart] = useState(false)

  const randNum = () => {
    let nums = ["rock", "paper", "scissors"]
    let rand = Math.floor(Math.random() * 3)
    return (nums[rand])
  }

  const [winner, setWinner] = useState("")

  const [classname, setClassname] = useState("rock")

  const select = ["rock", "paper", "scissors"]


  useEffect(() => {
    const interval = setInterval(() => {
      if (!gameStart) {
        setClassname(randNum())
      }
    }, 300)
    return () => clearInterval(interval)
  }, [gameStart])

  const game = (id) => {
    setGameStart(true)
    if ((((id === "rock") && (randNum() === "rock"))) || ((id === "paper") && (randNum() === "paper")) || ((id === "scissors") && (randNum() === "scissors"))) {
      setWinner("Draw")
      setClassname(id)
    } else if ((((id === "rock") && (randNum() === "paper")))) {
      setWinner("AI wins with Paper")
      setClassname("paper")
    } else if ((((id === "rock") && (randNum() === "scissors")))) {
      setWinner("You win with Rock")
      setClassname("scissors")
    } else if ((((id === "paper") && (randNum() === "rock")))) {
      setWinner("You win with Paper")
      setClassname("rock")
    } else if ((((id === "paper") && (randNum() === "scissors")))) {
      setWinner("AI wins with Scissors")
      setClassname("scissors")
    } else if ((((id === "scissors") && (randNum() === "rock")))) {
      setWinner("AI wins with Rock")
      setClassname("rock")
    } else if ((((id === "scissors") && (randNum() === "paper")))) {
      setWinner("You win with Scissors")
      setClassname("paper")
    }
    setTimeout(() => {
      window.location.reload()
    }, 3000)
  }

  return (
    <div className="App">
      <div className="game">
        {!gameStart && "Click on your title to play!!"}
        <div className="ai">
          <h1>AI</h1>
          <div className={classname === "rock" ? "randPic stone" : "randPic"}> </div>
          <div className={classname === "paper" ? "randPic paper" : "randPic"}></div>
          <div className={classname === "scissors" ? "randPic scissors" : "randPic"}></div>
        </div>
        <div>{gameStart ? <h1>{winner}</h1> : <p>VS</p>}</div>
        <div className="you">
          <h1>You</h1>
          <div className="pics">
            {select.map(select => {
              return (<div className="randPic" onClick={() => game(select)}></div>)
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
